/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Section, Content, Copy, Title, Link, Grid, GridSet, GridItem, Icon, DateRangePickerDropDown, MultiSelectDropDown, ListTable, Control, LineChart } from '@insticator/insticator-ui'; // iui-material
//utils
import { isAfterFourPM, getDateNYC } from '@insticator/insticator-ui'; // iui-utils
import { transpileTableBody, transpileByDateTableColumnHead, detailChartData } from 'utils/transpilers/datavisualization';
import { generateMetricsAPIString } from 'utils/fetchcontenthelpers';
import { getAllDetailData } from 'utils/api/detail';
import { handleSiteInDropDown, handleCountriesInDropDown, handleDevicesInDropDown, handleEmbedsInDropDown } from 'pages/dashboard/analytics/detail/detailhelpers';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/averageinview/averageinview_styles';



/* ========== ~~~~~~~~~~ DATA AVERAGE INVIEW ~~~~~~~~~~ ========== */
class AverageInView extends Component {
    constructor(props){
        super(props);
        this.topRank = 15;
        this.dataType = 'averageinview';
        this.state={
            controlSelected: `SITE`
        }
    }

    componentWillMount(){
        // let extendedProps = Object.keys(this.props.selectedSites).length ? {sites: this.props.selectedSites} : {topRank: this.topRank};
        let extendedProps = { topRank: this.topRank };
        this.fetchAverageInViewData(this.state.controlSelected, extendedProps);
    }
    //fetch data call
    fetchAverageInViewData = (controlSelected, extendAPIProps) => this.props.getDetailAverageInView(generateMetricsAPIString({accountUUID: this.props.accountUUID, dateRange: this.props.dateRange, viewType: controlSelected, ...extendAPIProps}));


    handleChartValue = data => {
        let value = data.total && data.total.aggregate ? data.total.aggregate : null;
        if (!value) return;
        return `${parseFloat(value).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
    };
    //-=-=-=Control actions-=-=-=//
    handleSitesControlClick = () => {
        this.props.updateDetailDropDown([], 'SITE');
        this.setState({controlSelected: 'SITE'});
        this.fetchAverageInViewData('SITE', {topRank: this.topRank});
    };
    handleDevicesControlClick = () => {
        this.setState({controlSelected: 'DEVICE'});
        this.fetchAverageInViewData('DEVICE', {topRank: this.topRank});
    };
    handleGeoControlClick = () => {
        this.setState({controlSelected: 'GEO'});
        this.props.fetchCountries(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
        this.fetchAverageInViewData('GEO', {topRank: this.topRank});
    };
    handleEmbedsControlClick = () => {
        this.setState({controlSelected: 'EMBED'});
        this.props.fetchEmbeds(this.props.accountUUID);
        this.fetchAverageInViewData('EMBED', {topRank: this.topRank});
    };
    //-=-=-=-=--Filter Data Dropdown actions -=-=-=-=//
    handleSitesFilterApply = sites => this.fetchAverageInViewData(this.state.controlSelected, { sites });
    handleDevicesFilterApply = devices => this.fetchAverageInViewData(this.state.controlSelected, { devices });
    handleGeoFilterApply = countries => this.fetchAverageInViewData(this.state.controlSelected, { countries });
    handleEmbedFilterApply = embeds => this.fetchAverageInViewData(this.state.controlSelected, { embeds });
    handleDateRangeApply = () => this.fetchAverageInViewData(this.state.controlSelected, {topRank: this.topRank});
    //this function will take selected items and populate reducer based on controlSelected state
    handleDropDownSelect = (items) => this.props.updateDetailDropDown(items, this.state.controlSelected);

    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName and excludedColumns
    exportCurrentProps = () => ({
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', '']
    });
    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName, excludedColumns, and a paramstring that is used to make a BE call to fetch data for all sites, adunits, countries, etc. depending on current viewType
    exportAllProps = () => ({
        apiCall: getAllDetailData('averageinview'),
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', ''],
        transpiler: transpileTableBody,
        paramString: generateMetricsAPIString({
            accountUUID: this.props.accountUUID,
            dateRange: this.props.dateRange,
            viewType: this.state.controlSelected,
            dataType: this.dataType
        })
    });

    render() {

        return(
            <Page name={`averageinview`} klass={`${this.props.classes.averageinview} filter-${this.state.controlSelected}`}>
                <Content>
                    <Section name={`detailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`detailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={`hand-point-left`} />
                                        <Title><h2>{'Average In View'}</h2></Title>
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown handleApply={this.handleDateRangeApply} range={this.props.dateRange} disabledDays={[ { after: new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} updateRange={this.props.updateDateRange} use4PMLogic={true} />
                                </GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`detailfilters`}>
                                <GridItem name={`filters`}>
                                    <GridItem><MultiSelectDropDown variant={'all-sites'} name={this.props.selectedSites.length === 1 ? 'site' : 'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleSitesFilterApply} items={handleSiteInDropDown(this.props.sites)} selectedItems={this.props.selectedSites} disabled={!this.props.sitesReceived}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedDevices.length === 1 ? 'device' : 'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleDevicesFilterApply} items={handleDevicesInDropDown(this.props.devices)} selectedItems={this.props.selectedDevices}/></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedCountries.length === 1 ? 'country' : 'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleGeoFilterApply} items={handleCountriesInDropDown(this.props.countries)}  selectedItems={this.props.selectedCountries} disabled={!this.props.countriesReceived} /></GridItem>
                                    <GridItem><MultiSelectDropDown name={this.props.selectedEmbeds.length === 1 ? 'embed' : 'embeds'} title={'All Embeds'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleEmbedFilterApply} items={handleEmbedsInDropDown(this.props.embeds)}  selectedItems={this.props.selectedEmbeds} disabled={!this.props.embedsReceived}/></GridItem>
                                </GridItem>
                                <GridItem direction={`horizontal`} name={`controls`}>
                                    <Control selected={this.state.controlSelected === `SITE`} text={`Sites`} value={`SITE`} handleSelect={this.handleSitesControlClick} />
                                    <Control selected={this.state.controlSelected === `DEVICE`} text={`Devices`} value={`DEVICE`} handleSelect={this.handleDevicesControlClick} />
                                    <Control selected={this.state.controlSelected === `GEO`} text={`Geo`} value={`GEO`} handleSelect={this.handleGeoControlClick} />
                                    <Control selected={this.state.controlSelected === `EMBED`} text={`Embeds`} value={`EMBED`} handleSelect={this.handleEmbedsControlClick} />
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`detailchart`}>
                        <LineChart
                            type={`detail`}
                            label={'Average In View'}
                            value={this.handleChartValue(this.props.averageInViewDetail)}
                            tooltip={'This is the number of Embed In-view events divided by total Embed load events'}
                            data={detailChartData(this.props.averageInViewDetail)}
                            metricType={'percent'}
                            yType={'percent'}
                            xType={'date'}
                            loading={this.props.averageInViewDetailFetching}
                        />
                    </Section>

                    <Section name={`detailtable`}>
                        <ListTable
                            name={`averageinview`}
                            type={`fixed-column`}
                            fixedColWidth={300}
                            size={`full`}
                            columnHeads={transpileByDateTableColumnHead(this.props.averageInViewDetail)}
                            data={transpileTableBody(this.props.averageInViewDetail, 'percent')}
                            exportData={this.exportCurrentProps()}
                            exportAll={this.exportAllProps()}
                            paginationLocation={`top`}
                            rowsPerPage={7}
                            loading={this.props.averageInViewDetailFetching}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export default injectSheet(styles)(AverageInView);
